import { V3CaptionGrey48 } from "../../ReusableStyledComponents/V3CaptionGrey48";
import { VerticalSpacing } from "../../VerticalSpacing";
import { V3Button } from "../../Button";
import { RightAlignPanel } from "../../ReusableStyledComponents/RightAlignPanel";
import { V3ButtonColor } from "../../Button/V3Button.types";
import { InlineLink } from "../../ReusableStyledComponents/InlineLink";
import { APPLICATION_ROUTES } from "../../../shared-logic/routes";

interface AddSourceFindArticlesProps {
    onBackHandler: () => void;
    computedSourceSlug?: string;
    sourceCanonicalSlug: string;
}

export const AddSourceFindArticles = ({ onBackHandler, computedSourceSlug, sourceCanonicalSlug }: AddSourceFindArticlesProps) => {
    return (
        <>
            <VerticalSpacing bottom={18}>
                <V3CaptionGrey48>You can find all content that's ever been imported to your Authory account in your Content Archive.</V3CaptionGrey48>
            </VerticalSpacing>
            {!!computedSourceSlug && sourceCanonicalSlug && (
                <VerticalSpacing bottom={18}>
                    <V3CaptionGrey48>
                        <InlineLink href={`${APPLICATION_ROUTES.CONTENT}?source=${sourceCanonicalSlug}`}>Here is a direct link</InlineLink> to filter
                        your Content Archive to only show pieces from <strong>{computedSourceSlug}</strong>.
                    </V3CaptionGrey48>
                </VerticalSpacing>
            )}
            <VerticalSpacing bottom={28}>
                <V3CaptionGrey48>
                    Whether the items from <strong>{computedSourceSlug}</strong> are displayed on your portfolio, depends on whether you've added a
                    collection to your portfolio that contains said items.{" "}
                    <InlineLink
                        href="https://authory.com/help/en/articles/9064271-how-to-make-your-portfolio-auto-updating#h_721a4cc0f2"
                        target="_blank"
                    >
                        Learn more in this quick guide
                    </InlineLink>
                    .
                </V3CaptionGrey48>
            </VerticalSpacing>
            <VerticalSpacing top={24}>
                <RightAlignPanel>
                    <div>
                        <V3Button text="Back" autoWidth onClick={onBackHandler} color={V3ButtonColor.secondary} />
                    </div>
                </RightAlignPanel>
            </VerticalSpacing>
        </>
    );
};
